import { Button } from './Button';
import type { ButtonHTMLAttributes } from 'react';
import { Icon } from './Icon';
import { Pill } from './Pill';
import { PillCluster } from './PillCluster';
import { Tabs, type TabsItem, type TabsProps } from './Tabs';

export type HeaderTab = Omit<TabsItem, 'htmlProps'> & {
  htmlProps?: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'dangerouslySetInnerHTML' | 'className'>;
};

export type HeaderPillSpec =
  | { type: 'title'; label: string; icon?: string; testId?: string; active?: boolean; onClick?: () => void }
  | (Pick<TabsProps, 'activeName' | 'onChange' | 'onItemClick'> & {
      type: 'tabs';
      items: HeaderTab[];
    });

export function HeaderPill({ value }: { value: HeaderPillSpec }) {
  if (value.type === 'title') {
    if (value.onClick) return <PillCluster><Pill><Button onClick={value.onClick} data-testid={value.testId}>
      <Icon name={value.icon ?? 'i-info'} />
      <span className="bar-title">{value.label}</span>
    </Button></Pill></PillCluster>;
    return <PillCluster><Pill><span className={value.active === false ? 'btn btn--static' : 'btn btn--static is-active'}>
      <Icon name={value.icon ?? 'i-info'} />
      <span className="bar-title" data-testid={value.testId}>{value.label}</span>
    </span></Pill></PillCluster>;
  }
  return (
    <Tabs
      items={value.items}
      activeName={value.activeName}
      onChange={value.onChange}
      onItemClick={value.onItemClick}
    />
  );
}
